import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const Clientes = ({ usuario, onLogout }) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [verInactivos, setVerInactivos] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ nombre: '', rif: '', telefono: '', direccion: '' });

  const esAdmin = usuario?.rol === 'admin';

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/clientes');
      setClientes(res.data);
    } catch { setError('Error cargando clientes'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const resetForm = () => { setForm({ nombre: '', rif: '', telefono: '', direccion: '' }); setEditando(null); setShowForm(false); setError(''); };

  const abrirEditar = (c) => { setForm({ nombre: c.nombre, rif: c.rif || '', telefono: c.telefono || '', direccion: c.direccion || '' }); setEditando(c.id); setShowForm(true); };

  const guardar = async (e) => {
    e.preventDefault(); setError('');
    try {
      editando ? await api.put(`/clientes/${editando}`, form) : await api.post('/clientes', form);
      resetForm(); cargar();
    } catch (err) { setError(err.response?.data?.detail || 'Error guardando cliente'); }
  };

  const eliminar = async (id) => { if (!window.confirm('¿Desactivar este cliente?')) return; try { await api.delete(`/clientes/${id}`); cargar(); } catch { setError('Error'); } };
  const restaurar = async (id) => { try { await api.patch(`/clientes/${id}/restaurar`); cargar(); } catch { setError('Error'); } };

  const activos = clientes.filter(c => c.activo);
  const inactivos = clientes.filter(c => !c.activo);
  const lista = verInactivos ? inactivos : activos;

  return (
    <Layout usuario={usuario} onLogout={onLogout} title="Clientes">
      <div style={S.headerRow}>
        <div style={S.tabs}>
          <button style={{ ...S.tabBtn, ...(!verInactivos ? S.tabActive : {}) }} onClick={() => setVerInactivos(false)}>Activos ({activos.length})</button>
          <button style={{ ...S.tabBtn, ...(verInactivos ? S.tabActive : {}) }} onClick={() => setVerInactivos(true)}>Inactivos ({inactivos.length})</button>
        </div>
        {esAdmin && !verInactivos && <button style={S.btnAdd} onClick={() => setShowForm(true)}>+ Nuevo Cliente</button>}
      </div>
      {error && <div style={S.error}>{error}</div>}
      {showForm && (
        <div style={S.formCard}>
          <h3 style={S.formTitle}>{editando ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>
          <form onSubmit={guardar} style={S.form}>
            <div style={S.formGrid}>
              <div style={{ ...S.group, gridColumn: '1 / -1' }}><label style={S.label}>Nombre *</label><input style={S.input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} placeholder="Nombre del cliente" required /></div>
              <div style={S.group}><label style={S.label}>RIF</label><input style={S.input} value={form.rif} onChange={e => setForm({ ...form, rif: e.target.value })} placeholder="Ej: 1-23456789-0" /></div>
              <div style={S.group}><label style={S.label}>Teléfono</label><input style={S.input} value={form.telefono} onChange={e => setForm({ ...form, telefono: e.target.value })} placeholder="809-000-0000" /></div>
              <div style={{ ...S.group, gridColumn: '1 / -1' }}><label style={S.label}>Dirección</label><input style={S.input} value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })} placeholder="Dirección de entrega" /></div>
            </div>
            <div style={S.formBtns}>
              <button type="button" style={S.btnCancel} onClick={resetForm}>Cancelar</button>
              <button type="submit" style={S.btnSave}>{editando ? 'Guardar' : 'Crear Cliente'}</button>
            </div>
          </form>
        </div>
      )}
      {loading ? <div style={S.loading}>Cargando...</div> : lista.length === 0 ? (
        <div style={S.empty}><div style={{ fontSize: '48px' }}>🏢</div><p>{verInactivos ? 'No hay clientes inactivos.' : 'No hay clientes registrados.'}</p></div>
      ) : (
        <div style={S.list}>
          {lista.map(c => (
            <div key={c.id} style={{ ...S.card, ...(c.activo ? {} : S.cardInactivo) }}>
              <div style={S.cardLeft}>
                <div style={S.clienteNombre}>{c.nombre}</div>
                <div style={S.clienteInfo}>
                  {c.rif && <span>🪪 {c.rif}</span>}
                  {c.telefono && <span>📞 {c.telefono}</span>}
                  {c.direccion && <span>📍 {c.direccion}</span>}
                </div>
              </div>
              {esAdmin && (
                <div style={S.cardBtns}>
                  {c.activo ? (
                    <><button style={S.btnEdit} onClick={() => abrirEditar(c)}>✏️</button><button style={S.btnDel} onClick={() => eliminar(c.id)}>🗑️</button></>
                  ) : (
                    <button style={S.btnRestore} onClick={() => restaurar(c.id)}>♻️</button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

const S = {
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' },
  tabs: { display: 'flex', gap: '8px' },
  tabBtn: { padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  tabActive: { background: '#1a1a1a', color: '#fff', borderColor: '#1a1a1a' },
  btnAdd: { background: '#CC0000', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', color: '#CC0000', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  formCard: { background: '#fff', borderRadius: '12px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' },
  formTitle: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 16px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  group: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#555' },
  input: { padding: '10px 12px', borderRadius: '7px', border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none', color: '#1a1a1a' },
  formBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  btnCancel: { padding: '10px 20px', borderRadius: '7px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  btnSave: { padding: '10px 20px', borderRadius: '7px', border: 'none', background: '#CC0000', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  loading: { textAlign: 'center', padding: '60px', color: '#666' },
  empty: { textAlign: 'center', padding: '60px', color: '#999', background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  card: { background: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' },
  cardInactivo: { opacity: 0.6, borderStyle: 'dashed' },
  cardLeft: { flex: 1 },
  clienteNombre: { fontSize: '14px', fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' },
  clienteInfo: { display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px', color: '#888' },
  cardBtns: { display: 'flex', gap: '6px', marginLeft: '12px' },
  btnEdit: { padding: '7px 10px', borderRadius: '6px', border: '1.5px solid #e0e0e0', background: '#fff', cursor: 'pointer', fontSize: '14px' },
  btnDel: { padding: '7px 10px', borderRadius: '6px', border: 'none', background: '#fff0f0', cursor: 'pointer', fontSize: '14px' },
  btnRestore: { padding: '7px 10px', borderRadius: '6px', border: 'none', background: '#f0fff4', cursor: 'pointer', fontSize: '14px' },
};

export default Clientes;
